import { render, staticRenderFns } from "./GoldenTicketsAdmin.vue?vue&type=template&id=4333cab7"
import script from "./GoldenTicketsAdmin.vue?vue&type=script&lang=js"
export * from "./GoldenTicketsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports